_options$resolver